module.exports = __webpack_public_path__ + "static/img/charitable-activities-01.c5660bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/charitable-activities-01.jpg
// module id = FSaL
// module chunks = 100